import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingPanelComponent } from "../components/loading-panel/loading-panel.component";
import { ModalComponent } from "../components/modal/modal.component";
import { GridComponent } from "../components/grid/grid.component";
import { FilterComponent } from "../components/filter/filter.component";
import { DetailComponent } from "../components/detail/detail.component";
import { HeaderComponent } from "../components/header/header.component";
import { PipeModule } from "../pipes/pipe.module";
import { CoreModule } from "../../core/core.module";
import { GridExpandableComponent } from "./grid-expandable/grid-expandable.component";
import { DirectiveModule } from "../../directives/directive.module";
import { DialogModule } from "./dialog/dialog.module";
import { AlertComponent } from "./alert/alert.component";
import { DialogImportFileComponent } from './dialog-import-file/dialog-import-file.component'
import { ToastModule } from "./toast/toast.module";
import { InputErrorComponent } from "./input-error/input-error.component";
import { ChangePasswordDialogComponent } from "./change-password-dialog/change-password-dialog.component";
import { NavBarModule } from "./header/nav-bar/navbar.module";
import { InputMessageComponent } from "./input-message/input-message.component";
import { NewsPanelComponent } from "./news-panel/news-panel.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { SearchCompanyComponent } from "./pbm/companies/search-company/search-company.component";
import { EditCompanyComponent } from "./pbm/companies/edit-company/edit-company.component";
import { DeleteContactDialogComponent } from "./pbm/companies/delete-contact-dialog/delete-contact-dialog.component";
import { CompanyMasterDataDialogComponent } from "./pbm/companies/company-master-data-dialog/company-master-data-dialog.component";
import { SearchBeneficiaryComponent } from "./pbm/beneficiaries/search-beneficiary/search-beneficiary.component";
import { ExportBeneficiariesComponent } from "./pbm/beneficiaries/export-beneficiaries/export-beneficiaries.component"
import { RegistrationBeneficiaryComponent } from "./pbm/beneficiaries/registration-beneficiary/registration-beneficiary.component";
import { RegistrationBeneficiariesComponent } from "./pbm/beneficiaries/registration-beneficiaries/registration-beneficiaries.component";
import { EditBeneficiaryComponent } from "./pbm/beneficiaries/edit-beneficiary/edit-beneficiary.component";
import { SalesHistoryCompaniesComponent } from "./pbm/sales-histories/sales-history-companies/sales-history-companies.component";
import { SalesHistoryCompanyComponent } from "./pbm/sales-histories/sales-history-company/sales-history-company.component";
import { SalesHistoryCompanyCardComponent } from "./pbm/sales-histories/sales-history-companies/sales-history-company-card/sales-history-company-card.component";
import { CompanyContactDialogComponent } from "./pbm/companies/company-contact-dialog/company-contact-dialog.component";
import { SearchUserComponent } from "./pbm/users/search-user/search-user.component";
import { RegisterUserComponent } from "./pbm/users/register-user/register-user.component";
import { AutoCompleteSearchComponent } from "./auto-complete-search/auto-complete-search.component";
import { DynamicComponentComponent } from "./dynamic-component/dynamic-component.component";
import { FinancialStatementCompanyComponent } from "./pbm/financial-statement/financial-statement-company/financial-statement-company.component";
import { SearchFinancialStatementComponent } from "./pbm/financial-statement/search-financial-statement/search-financial-statement.component";
import { FinancialStatementBeneficiaryComponent } from "./pbm/financial-statement/financial-statement-beneficiary/financial-statement-beneficiary.component";
import { CardBlockDialogComponent } from "./pbm/beneficiaries/dialogs/card-block-dialog/card-block-dialog.component";
import { BlockBeneficiariesComponent } from "./pbm/beneficiaries/block-beneficiaries/block-beneficiaries.component";
import { EditDependentComponent } from "./pbm/beneficiaries/edit-dependent/edit-dependent.component";
import { UnblockBeneficiariesComponent } from "./pbm/beneficiaries/unblock-beneficiaries/unblock-beneficiaries.component";
import { CardUnblockDialogComponent } from "./pbm/beneficiaries/dialogs/card-unblock-dialog/card-unblock-dialog.component";
import { AddJobDescriptionDialog } from "./pbm/shared/dialogs/add-job-description-dialog/add-job-description-dialog.component";
import { ConfirmDialog } from "./pbm/shared/dialogs/confirm-dialog/confirm-dialog.component";
import { CardOrderDialogComponent } from "./pbm/beneficiaries/dialogs/card-order-dialog/card-order-dialog.component";
import { BeneficiaryUsageIndicatorComponent } from "./pbm/home/beneficiary-usage-indicator-component/beneficiary-usage-indicator.component";
import { IndicatorFilterComponent } from "./pbm/home/indicator-filter-component/indicator-filter.component";
import { CompanyFilterDialogComponent } from "./pbm/home/dialogs/company-filter-dialog/company-filter-dialog.component";
import { CompanyBalanceComponent } from "./pbm/home/company-balance/company-balance.component";
import { TopTenProductsIndicatorComponent } from "./pbm/home/top-ten-products-indicator-component/top-ten-products-indicator.component";
import { CompanySubsidiaryBalanceComponent } from "./pbm/home/company-subsidiary-balance/company-subsidiary-balance.component";
import { ProductSubtypeIndicatorComponent } from "./pbm/home/product-subtype-indicator-component/product-subtype-indicator.component";
import { TopTenTherapeuticClassComponent } from "./pbm/home/top-ten-therapeutic-class/top-ten-therapeutic-class.component";
import { TopTenNetworkIndicatorComponent } from "./pbm/home/top-ten-network-indicator-component/top-ten-networks-indicator.component";
import { TopTenPractitionerIndicatorComponent } from "./pbm/home/top-ten-practitioner-indicator-component/top-ten-practitioner-indicator.component";
import { SearchFinancialReportComponent } from "./pbm/financial-report/search-financial-report/search-financial-report.component";
import { CompanyFinancialReportComponent } from "./pbm/financial-report/company-financial-report/company-financial-report.component";
import { IndicatorLoaderComponent } from "./pbm/home/indicator-loader-component/indicator-loader.component";
import { EditLpmComponent } from "./pbm/lpm-management/edit-lpm/edit-lpm.component";
import { AddIndustryDiscountsComponent } from "./pbm/lpm-management/add-industry-discounts/add-industry-discounts.component";
import { InlineEditComponent } from "./pbm/lpm-management/edit-lpm/inline-edit/inline-edit.component";
import { SearchLpmManagementComponent } from "./pbm/lpm-management/search-lpm-management/search-lpm-management.component";
import { SearchProductComponent } from "./pbm/product-management/search-product/search-product.component";
import { EditProductComponent } from "./pbm/product-management/edit-product/edit-product.component";
import { EditProductPricingComponent } from "./pbm/product-management/edit-product-pricing/edit-product-pricing.component";
import { AddLpmProductDialogComponent } from "./pbm/lpm-management/edit-lpm/add-lpm-product-dialog/add-lpm-product-dialog.component";
import { InsertProductComponent } from "./pbm/product-management/insert-product/insert-product.component";
import { SearchPractitionerComponent } from "./pbm/practitioner-management/search-practitioner/search-practitioner.component";
import { RegisterPractitionerComponent } from "./pbm/practitioner-management/register-practitioner/register-practitioner.component";
import { EditPractitionerComponent } from "./pbm/practitioner-management/edit-practitioner/edit-practitioner.component";
import { SearchClusterManagementComponent } from "./pbm/cluster-management/search-cluster-management/search-cluster-management.component";
import { EditClusterComponent } from "./pbm/cluster-management/edit-cluster/edit-cluster.component";
import { AddProductDialogComponent } from "./pbm/cluster-management/edit-cluster/add-product-dialog/add-product-dialog.component";
import { AddBatchProductDialogComponent } from "./pbm/cluster-management/edit-cluster/add-batch-product-dialog/add-batch-product-dialog.component";
import { CreateCompanyComponent } from "./pbm/companies/create-company/create-company.component";
import { RegisterCompanyDataQualityComponent } from "./pbm/companies/register-company-data-quality/register-company-data-quality.component";
import { ExportInfoDialogComponent } from "./pbm/beneficiaries/registration-beneficiaries/export-info-dialog/export-info-dialog.component";
import { MenuItemComponent } from "./sidenav/menu-item/menu-item.component";
import { DatePipe } from "@angular/common";
import { VinculatedSocialnumberDialogComponent } from "./pbm/beneficiaries/registration-beneficiary/vinculated-socialnumber/vinculated-socialnumber-dialog.component";
import { OverlayModule } from "@angular/cdk/overlay";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BaseChartDirective } from 'ng2-charts';
import { ImmediatePaymentService } from "./pbm/benefits/services/immediate.payment.service";
import { FinancialStatementFilterComponent } from "./pbm/financial-statement/financial-statement-filter/financial-statement-filter.component";
import { SelectAutoCompleteComponent } from "./pbm/shared/select-auto-complete/select-auto-complete.component";
import { NgxPrintModule } from "ngx-print";
import { CustomInputComponent } from "./pbm/shared/components/custom-input/custom-input.component";

@NgModule({
    declarations: [
        LoadingPanelComponent,
        GridComponent,
        FilterComponent,
        ModalComponent,
        DetailComponent,
        HeaderComponent,
        GridExpandableComponent,
        AlertComponent,
        DialogImportFileComponent,
        InputErrorComponent,
        InputMessageComponent,
        ChangePasswordDialogComponent,
        InputMessageComponent,
        SidenavComponent,
        IndicatorFilterComponent,
        BeneficiaryUsageIndicatorComponent,
        TopTenProductsIndicatorComponent,
        TopTenNetworkIndicatorComponent,
        ProductSubtypeIndicatorComponent,
        CompanyBalanceComponent,
        CompanyFilterDialogComponent,
        SearchCompanyComponent,
        RegisterCompanyDataQualityComponent,
        EditCompanyComponent,
        CreateCompanyComponent,
        SearchBeneficiaryComponent,
        ExportBeneficiariesComponent,
        RegistrationBeneficiaryComponent,
        DeleteContactDialogComponent,
        RegistrationBeneficiariesComponent,
        EditBeneficiaryComponent,
        CardBlockDialogComponent,
        CardUnblockDialogComponent,
        CardOrderDialogComponent,
        AddJobDescriptionDialog,
        CompanyMasterDataDialogComponent,
        SalesHistoryCompaniesComponent,
        SalesHistoryCompanyComponent,
        SalesHistoryCompanyCardComponent,
        CompanyContactDialogComponent,
        SearchUserComponent,
        RegisterUserComponent,
        AutoCompleteSearchComponent,
        SearchFinancialStatementComponent,
        FinancialStatementCompanyComponent,
        FinancialStatementBeneficiaryComponent,
        DynamicComponentComponent,
        BlockBeneficiariesComponent,
        EditDependentComponent,
        UnblockBeneficiariesComponent,
        ConfirmDialog,
        CompanyBalanceComponent,
        CompanySubsidiaryBalanceComponent,
        TopTenTherapeuticClassComponent,
        TopTenPractitionerIndicatorComponent,
        SearchFinancialReportComponent,
        CompanyFinancialReportComponent,
        IndicatorLoaderComponent,
        SearchLpmManagementComponent,
        EditLpmComponent,
        AddIndustryDiscountsComponent,
        InlineEditComponent,
        SearchProductComponent,
        EditProductComponent,
        EditProductPricingComponent,
        AddLpmProductDialogComponent,
        InsertProductComponent,
        SearchPractitionerComponent,
        RegisterPractitionerComponent,
        EditPractitionerComponent,
        SearchClusterManagementComponent,
        EditClusterComponent,
        AddProductDialogComponent,
        AddBatchProductDialogComponent,
        ExportInfoDialogComponent,
        MenuItemComponent,
        VinculatedSocialnumberDialogComponent,
    ],
    imports: [
    CoreModule,
    DialogModule,
    ToastModule,
    NavBarModule,
    FormsModule,
    OverlayModule,
    ReactiveFormsModule,
    BaseChartDirective,
    MatTooltipModule,
    MatDatepickerModule,
    MatTableModule,
    PipeModule,
    DirectiveModule,
    FinancialStatementFilterComponent,
    SelectAutoCompleteComponent,
    NgxPrintModule,
    CustomInputComponent
],
    exports: [
        LoadingPanelComponent,
        GridComponent,
        DialogModule,
        FilterComponent,
        ModalComponent,
        DetailComponent,
        HeaderComponent,
        NewsPanelComponent,
        GridExpandableComponent,
        AlertComponent,
        DialogImportFileComponent,
        InputErrorComponent,
        InputMessageComponent,
        SidenavComponent,
        IndicatorFilterComponent,
        BeneficiaryUsageIndicatorComponent,
        TopTenProductsIndicatorComponent,
        TopTenNetworkIndicatorComponent,
        ProductSubtypeIndicatorComponent,
        CompanyBalanceComponent,
        CompanyFilterDialogComponent,
        SearchCompanyComponent,
        RegisterCompanyDataQualityComponent,
        EditCompanyComponent,
        CreateCompanyComponent,
        SearchBeneficiaryComponent,
        ExportBeneficiariesComponent,
        RegistrationBeneficiaryComponent,
        DeleteContactDialogComponent,
        CardBlockDialogComponent,
        CardUnblockDialogComponent,
        CardOrderDialogComponent,
        AddJobDescriptionDialog,
        CompanyMasterDataDialogComponent,
        CompanyContactDialogComponent,
        AutoCompleteSearchComponent,
        DynamicComponentComponent,
        ConfirmDialog,
        CompanyBalanceComponent,
        CompanySubsidiaryBalanceComponent,
        TopTenTherapeuticClassComponent,
        TopTenPractitionerIndicatorComponent,
    ],
    providers: [
        { provide: MAT_DIALOG_DATA, useValue: [] },
        DatePipe,
        ImmediatePaymentService
    ]
})
export class ComponentModule { }
